import { formatAmount } from './formatAmount';
import { OfferReward } from './getOfferReward';

/** An offer's reward at the current selection, ready to render. */
export type FormattedOfferReward =
  | { kind: 'value'; value: string }
  | { kind: 'noFixedValue' }
  | { kind: 'none' };

export const formatOfferReward = (
  reward: OfferReward,
  currency: string,
): FormattedOfferReward =>
  reward.kind === 'value'
    ? { kind: 'value', value: formatAmount(reward.value, currency) }
    : reward;
